module.exports = __webpack_public_path__ + "static/media/kasbonCard.8b154e0f.png";